import { Typography, useTheme } from "@outschool/backpack";
import { Trans, useTranslation } from "@outschool/localization";
import { RollingTexts } from "@outschool/ui-components-website";
import React from "react";

export default function HeaderTitle() {
  const { t } = useTranslation(
    "client\\components\\tutoring\\TutoringPage\\HeaderTitle"
  );
  const theme = useTheme();

  const teachingTopics = [
    t("reading tutors"),
    t("math tutors"),
    t("writing tutors"),
    t("Spanish tutors")
  ];

  return (
    <Typography variant="h1" sx={{ textAlign: "left" }}>
      <Trans t={t}>
        Trusted{" "}
        <RollingTexts
          textSx={{ color: theme.palette.primary.main }}
          texts={teachingTopics}
          pauseSeconds={1.25}
          transitionSeconds={1.25}
        />{" "}
        anytime, anywhere.
      </Trans>
    </Typography>
  );
}
